module.exports = __webpack_public_path__ + "media/entities/1113-ce517987.png";